(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-circuit-breaker"]) return;
  try {
    
  (() => {
    const initializeBreakerCatalog = (root) => {
      if (root.dataset.breakerReady === 'true') return;
      root.dataset.breakerReady = 'true';

      const cards = Array.from(root.querySelectorAll('[data-breaker-card]'));
      const filterButtons = Array.from(root.querySelectorAll('[data-breaker-filter]'));
      const searchInput = root.querySelector('[data-breaker-search]');
      const resultCount = root.querySelector('[data-breaker-result-count]');
      let activeFilter = 'all';

      const updateResults = () => {
        const query = searchInput ? searchInput.value.trim().toLowerCase() : '';
        let visibleCount = 0;

        cards.forEach((card) => {
          const matchesFamily = activeFilter === 'all' || card.dataset.breakerFamily === activeFilter;
          const matchesSearch = !query || (card.dataset.breakerSearchText || '').toLowerCase().includes(query);
          const isVisible = matchesFamily && matchesSearch;
          card.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });

        if (resultCount) {
          const template = resultCount.dataset.countTemplate || '__COUNT__ models shown';
          resultCount.textContent = template.replace('__COUNT__', String(visibleCount));
        }
      };

      const setFilter = (filter) => {
        activeFilter = filter;
        filterButtons.forEach((button) => {
          const isActive = button.dataset.breakerFilter === filter;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });
        updateResults();
      };

      filterButtons.forEach((button) => {
        button.addEventListener('click', () => {
          setFilter(button.dataset.breakerFilter || 'all');
        });
      });

      if (searchInput) searchInput.addEventListener('input', updateResults);
      updateResults();
    };

    document.querySelectorAll('[data-breaker-catalog]').forEach(initializeBreakerCatalog);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-breaker-catalog]').forEach(initializeBreakerCatalog);
      if (event.target.matches('[data-breaker-catalog]')) initializeBreakerCatalog(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-catalog"]) return;
  try {
    
  (() => {
    const initializeBreakerCatalog = (root) => {
      if (root.dataset.breakerReady === 'true') return;
      root.dataset.breakerReady = 'true';

      const cards = Array.from(root.querySelectorAll('[data-breaker-card]'));
      const filterButtons = Array.from(root.querySelectorAll('[data-breaker-filter]'));
      const searchInput = root.querySelector('[data-breaker-search]');
      const resultCount = root.querySelector('[data-breaker-result-count]');
      const catalog = root.querySelector('.pcf-catalog');
      let activeFilter = 'all';

      const updateResults = () => {
        const query = searchInput ? searchInput.value.trim().toLowerCase() : '';
        let visibleCount = 0;

        cards.forEach((card) => {
          const matchesFamily = activeFilter === 'all' || card.dataset.breakerFamily === activeFilter;
          const matchesSearch = !query || (card.dataset.breakerSearchText || '').toLowerCase().includes(query);
          const isVisible = matchesFamily && matchesSearch;
          card.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });

        if (resultCount) {
          const template = resultCount.dataset.countTemplate || '__COUNT__ models shown';
          resultCount.textContent = template.replace('__COUNT__', String(visibleCount));
        }
      };

      const setFilter = (filter, shouldScroll) => {
        activeFilter = filter;
        filterButtons.forEach((button) => {
          const isActive = button.dataset.breakerFilter === filter;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });
        updateResults();
        if (shouldScroll && catalog) {
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          catalog.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        }
      };

      filterButtons.forEach((button) => {
        button.addEventListener('click', () => {
          setFilter(button.dataset.breakerFilter || 'all', button.closest('.pcf-breaker-selector') !== null);
        });
      });

      if (searchInput) searchInput.addEventListener('input', updateResults);
      updateResults();
    };

    document.querySelectorAll('[data-breaker-catalog]').forEach(initializeBreakerCatalog);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-breaker-catalog]').forEach(initializeBreakerCatalog);
      if (event.target.matches('[data-breaker-catalog]')) initializeBreakerCatalog(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-p-family"]) return;
  try {
    
  (() => {
    for (const root of document.querySelectorAll('[data-pf-root]')) {
      const variants = JSON.parse(root.querySelector('[data-pf-variants]').textContent);
      const optionNames = ['Shackle', 'Keying', 'Color'];
      const currency = root.dataset.currency || 'USD';
      const choosePhoto = (name) => {
        root.querySelectorAll('[data-pf-photo]').forEach(el => { el.hidden = el.dataset.pfPhoto !== name; });
        root.querySelectorAll('[data-pf-thumb]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.pfThumb === name)));
      };
      const update = () => {
        const selected = Object.fromEntries(optionNames.map((name, index) => [name, root.querySelector(`input[name="option-${index + 1}"]:checked`)?.value]));
        const variant = variants.find(item => item.options.every((value, index) => value === selected[optionNames[index]]));
        if (!variant) { root.querySelector('[data-pf-add]').disabled = true; return; }
        root.querySelector('[data-pf-variant-id]').value = variant.id;
        root.querySelector('[data-pf-sku]').textContent = variant.sku;
        root.querySelector('[data-pf-price]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(variant.price / 100);
        root.querySelector('[data-pf-summary]').textContent = variant.public_title || variant.title;
        root.querySelector('[data-pf-add]').disabled = !variant.available;
        root.querySelector('[data-pf-add]').textContent = variant.available ? 'Add to cart' : 'Sold out';
        optionNames.forEach(name => { root.querySelector(`[data-pf-selected="${name}"]`).textContent = selected[name]; });
        root.querySelector('[data-pf-image-note]').textContent = selected.Color === 'Red' ? 'Actual product photo: red body. Keying is selected by SKU.' : 'Photo shows the red version. Your selected color and SKU are shown on the right.';
        const quote = root.querySelector('[data-open-rfq]');
        quote.dataset.sku = variant.sku;
        quote.dataset.variant = variant.title;
        choosePhoto(selected.Shackle);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      };
      root.querySelectorAll('.pf__choice-input').forEach(input => input.addEventListener('change', update));
      root.querySelectorAll('[data-pf-thumb]').forEach(button => button.addEventListener('click', () => choosePhoto(button.dataset.pfThumb)));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-safety-padlocks"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const filters = [...root.querySelectorAll('[data-spc-filter]')];
      const cards = [...root.querySelectorAll('[data-spc-card]')];
      const quickButtons = [...root.querySelectorAll('[data-spc-quick]')];
      const bodyButtons = [...root.querySelectorAll('[data-spc-quick-body]')];
      const search = root.querySelector('[data-spc-search]');
      const sort = root.querySelector('[data-spc-sort]');
      const grid = root.querySelector('[data-spc-grid]');
      const count = root.querySelector('[data-spc-count]');
      const active = root.querySelector('[data-spc-active]');
      const empty = root.querySelector('[data-spc-empty]');
      const reset = root.querySelector('[data-spc-reset]');
      const panel = root.querySelector('[data-spc-filter-panel]');
      const toggle = root.querySelector('[data-spc-filter-toggle]');
      const catalog = root.querySelector('.spc-catalog-section');

      const valuesFor = (group) => filters.filter((input) => input.dataset.group === group && input.checked).map((input) => input.value);

      const renderActive = () => {
        const selected = filters.filter((input) => input.checked);
        active.replaceChildren();
        if (!selected.length) {
          const chip = document.createElement('span');
          chip.textContent = root.dataset.allLabel;
          active.append(chip);
          return;
        }
        selected.forEach((input) => {
          const chip = document.createElement('span');
          chip.textContent = input.nextElementSibling?.textContent || input.value;
          active.append(chip);
        });
      };

      const apply = () => {
        const materials = valuesFor('material');
        const bodies = valuesFor('body');
        const environments = valuesFor('environment');
        const query = (search?.value || '').trim().toLowerCase();
        let visible = 0;

        cards.forEach((card) => {
          const show = (!materials.length || materials.includes(card.dataset.material))
            && (!bodies.length || bodies.includes(card.dataset.body))
            && (!environments.length || environments.includes(card.dataset.environment))
            && (!query || card.dataset.search.includes(query));
          card.hidden = !show;
          if (show) visible += 1;
        });

        if (count) count.textContent = String(visible);
        if (empty) empty.hidden = visible !== 0;
        renderActive();
        quickButtons.forEach((button) => button.setAttribute('aria-pressed', String(materials.length === 1 && materials[0] === button.dataset.spcQuick)));
      };

      filters.forEach((input) => input.addEventListener('change', apply));
      search?.addEventListener('input', apply);
      reset?.addEventListener('click', () => {
        filters.forEach((input) => { input.checked = false; });
        if (search) search.value = '';
        apply();
      });

      quickButtons.forEach((button) => button.addEventListener('click', () => {
        filters.filter((input) => input.dataset.group === 'material').forEach((input) => { input.checked = input.value === button.dataset.spcQuick; });
        apply();
        catalog?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }));

      bodyButtons.forEach((button) => button.addEventListener('click', () => {
        filters.filter((input) => input.dataset.group === 'body').forEach((input) => { input.checked = input.value === button.dataset.spcQuickBody; });
        apply();
        catalog?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }));

      sort?.addEventListener('change', () => {
        const sorted = [...cards].sort((a, b) => sort.value === 'title'
          ? a.dataset.title.localeCompare(b.dataset.title)
          : Number(a.dataset.order) - Number(b.dataset.order));
        sorted.forEach((card) => grid?.append(card));
      });

      toggle?.addEventListener('click', () => {
        const open = panel?.classList.toggle('is-open') || false;
        toggle.setAttribute('aria-expanded', String(open));
      });

      apply();
    };

    document.querySelectorAll('[data-spc]').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('[data-spc]');
      if (root) initialise(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-valve-lockouts"]) return;
  try {
    
  (() => {
    const initializeValveCatalog = (root) => {
      if (root.dataset.valveReady === 'true') return;
      root.dataset.valveReady = 'true';

      const cards = Array.from(root.querySelectorAll('[data-valve-card]'));
      const filterButtons = Array.from(root.querySelectorAll('[data-valve-filter]'));
      const searchInput = root.querySelector('[data-valve-search]');
      const resultCount = root.querySelector('[data-valve-result-count]');
      let activeFilter = 'all';

      const updateResults = () => {
        const query = searchInput ? searchInput.value.trim().toLowerCase() : '';
        let visibleCount = 0;

        cards.forEach((card) => {
          const matchesFamily = activeFilter === 'all' || card.dataset.valveFamily === activeFilter;
          const matchesSearch = !query || (card.dataset.valveSearchText || '').toLowerCase().includes(query);
          const isVisible = matchesFamily && matchesSearch;
          card.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });

        if (resultCount) {
          const template = resultCount.dataset.countTemplate || '__COUNT__ models shown';
          resultCount.textContent = template.replace('__COUNT__', String(visibleCount));
        }
      };

      const setFilter = (filter) => {
        activeFilter = filter;
        filterButtons.forEach((button) => {
          const isActive = button.dataset.valveFilter === filter;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });
        updateResults();
      };

      filterButtons.forEach((button) => {
        button.addEventListener('click', () => {
          setFilter(button.dataset.valveFilter || 'all');
        });
      });

      if (searchInput) searchInput.addEventListener('input', updateResults);
      updateResults();
    };

    document.querySelectorAll('[data-valve-catalog]').forEach(initializeValveCatalog);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-valve-catalog]').forEach(initializeValveCatalog);
      if (event.target.matches('[data-valve-catalog]')) initializeValveCatalog(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
